import { useMutation } from "react-query";
import { COMPANY_CREATION_URL } from "../../constants";

const netvisorLoginPath = `${COMPANY_CREATION_URL}/v1/netvisorlogin`;

export class NetvisorLoginError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    // Restore the prototype chain so `instanceof NetvisorLoginError` works after TS ES5 downlevel.
    Object.setPrototypeOf(this, NetvisorLoginError.prototype);
    this.name = "NetvisorLoginError";
    this.status = status;
  }
}

export function useNetvisorLogin() {
  return useMutation(async () => {
    const response = await fetch(netvisorLoginPath, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new NetvisorLoginError(
        `Network response was not ok, status: ${response.status}`,
        response.status
      );
    }

    return response.json();
  });
}
